import { TIMEENTRY_INDEX, TIMEENTRY_ADD, TIMEENTRY_BY_SALESLINE, TIMEENTRY_GET } from '../actions/timeEntry'
import apiCall from '../../utils/api'

const state = {
  all: []
}

const getters = {
  [TIMEENTRY_GET]: (state, getters) => {
    return state.all
  },
  [TIMEENTRY_BY_SALESLINE]: (state, getters) => (salesLineId) => {
    return state.all.filter(timeEntry => timeEntry.sales_line_id === salesLineId)
  }
}

const actions = {
  [TIMEENTRY_INDEX]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      apiCall({url: 'api/timeentries', method: 'GET'})
        .then(resp => {
          commit(TIMEENTRY_INDEX, resp.data)
        })
      resolve()
    })
  },
  [TIMEENTRY_GET]: ({commit, dispatch}, id) => {
    return new Promise((resolve, reject) => {
      apiCall({url: 'api/timeentries/' + id, method: 'GET'})
        .then(resp => {
          resolve(resp)
        })
    })
  },
  [TIMEENTRY_ADD]: ({commit, dispatch}, data) => {
    return new Promise((resolve, reject) => {
      apiCall({url: 'api/timeentries', method: 'POST', ...data}).then(resp => {
        commit(TIMEENTRY_ADD, resp.data)
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  }
}

const mutations = {
  [TIMEENTRY_INDEX]: (state, resp) => {
    state.all = resp
  },
  [TIMEENTRY_ADD]: (state, timeEntry) => {
    state.all = [timeEntry, ...state.all]
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/timeEntry.js